import { imageDescriptions } from "@/content/image-descriptions";

// Reuse the established live image library so alt text describes the displayed artwork.
const sources: Record<string, string> = {
  "2023-seo-lessons-and-forward-view": "/images/brand/2023-seo-lessons-and-forward-view-1200.webp",
  "2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns":
    "/images/brand/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns-1200.webp",
  "a-practical-plan-for-ai-driven-search-a-ninety-day-playbook":
    "/images/brand/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook-1200.webp",
  "a-year-of-change-googles-2021-algorithm-updates":
    "/images/brand/a-year-of-change-googles-2021-algorithm-updates-1200.webp",
  accountants: "/images/brand/accountants-1200.webp",
  "ai-in-search-the-rise-of-generative-experiences":
    "/images/brand/ai-in-search-the-rise-of-generative-experiences-1200.webp",
  "aligning-seo-with-revenue-goals-in-2025":
    "/images/brand/aligning-seo-with-revenue-goals-in-2025-1200.webp",
  "barnsley-seo-for-accountants-how-to-attract-higher-value-leads":
    "/images/brand/barnsley-seo-for-accountants-how-to-attract-higher-value-leads-1200.webp",
  "barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests":
    "/images/brand/barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests-1200.webp",
  "barnsley-seo-for-dental-and-health-clinics-local-patient-growth":
    "/images/brand/barnsley-seo-for-dental-and-health-clinics-local-patient-growth-1200.webp",
  "barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries":
    "/images/brand/barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries-1200.webp",
  "bert-expansion-and-passage-indexing":
    "/images/brand/bert-expansion-and-passage-indexing-1200.webp",
  "building-a-website-that-supports-seo-and-business-growth":
    "/images/brand/building-a-website-that-supports-seo-and-business-growth-1200.webp",
  "building-structured-data-and-schema-markup":
    "/images/brand/building-structured-data-and-schema-markup-1200.webp",
  "common-seo-mistakes-that-hold-small-businesses-back":
    "/images/brand/common-seo-mistakes-that-hold-small-businesses-back-1200.webp",
  "connecting-seo-to-revenue-in-an-ai-influenced-world-revision":
    "/images/brand/connecting-seo-to-revenue-in-an-ai-influenced-world-revision-1200.webp",
  contact: "/images/brand/contact-1200.webp",
  "crawl-audit": "/images/brand/crawl-audit-1200.webp",
  "creating-an-seo-plan-that-supports-long-term-success":
    "/images/brand/creating-an-seo-plan-that-supports-long-term-success-1200.webp",
  credentials: "/images/brand/credentials-1200.webp",
  "data-driven-decisions-leveraging-ga4-for-seo-success":
    "/images/brand/data-driven-decisions-leveraging-ga4-for-seo-success-1200.webp",
  "decoding-googles-2022-algorithm-updates":
    "/images/brand/decoding-googles-2022-algorithm-updates-1200.webp",
  development: "/images/brand/development-1200.webp",
  "eat-and-the-evolution-of-content": "/images/brand/eat-and-the-evolution-of-content-1200.webp",
  ecommerce: "/images/brand/ecommerce-1200.webp",
  "eeat-and-content-quality": "/images/brand/eeat-and-content-quality-1200.webp",
  electricians: "/images/brand/electricians-1200.webp",
  "emerging-seo-specialties-aeo-geo-and-beyond":
    "/images/brand/emerging-seo-specialties-aeo-geo-and-beyond-1200.webp",
  "enterprise-seo-and-collaboration": "/images/brand/enterprise-seo-and-collaboration-1200.webp",
  "firstparty-data-and-privacy": "/images/brand/firstparty-data-and-privacy-1200.webp",
  "generative-ai-and-content-creation-balancing-automation-and-authenticity":
    "/images/brand/generative-ai-and-content-creation-balancing-automation-and-authenticity-1200.webp",
  "generative-ais-role-in-search-in-2023":
    "/images/brand/generative-ais-role-in-search-in-2023-1200.webp",
  hairdressers: "/images/brand/hairdressers-1200.webp",
  hosting: "/images/brand/hosting-1200.webp",
  "how-accountancy-websites-can-improve-enquiry-quality":
    "/images/brand/how-accountancy-websites-can-improve-enquiry-quality-1200.webp",
  "how-builders-can-get-more-quote-requests-from-google":
    "/images/brand/how-builders-can-get-more-quote-requests-from-google-1200.webp",
  "how-hairdressers-can-get-more-bookings-from-google":
    "/images/brand/how-hairdressers-can-get-more-bookings-from-google-1200.webp",
  "how-law-firms-can-improve-search-led-enquiry-quality":
    "/images/brand/how-law-firms-can-improve-search-led-enquiry-quality-1200.webp",
  "how-long-does-seo-take-in-barnsley-a-practical-timeline":
    "/images/brand/how-long-does-seo-take-in-barnsley-a-practical-timeline-1200.webp",
  "how-long-does-seo-take-in-sheffield-a-practical-timeline":
    "/images/brand/how-long-does-seo-take-in-sheffield-a-practical-timeline-1200.webp",
  "how-much-does-seo-cost-for-a-barnsley-business-in-2026":
    "/images/brand/how-much-does-seo-cost-for-a-barnsley-business-in-2026-1200.webp",
  "how-much-does-seo-cost-for-a-wakefield-business-in-2026":
    "/images/brand/how-much-does-seo-cost-for-a-wakefield-business-in-2026-1200.webp",
  "how-seo-builds-momentum-over-time-for-small-businesses":
    "/images/brand/how-seo-builds-momentum-over-time-for-small-businesses-1200.webp",
  "how-to-hire-an-seo-consultant": "/images/brand/how-to-hire-an-seo-consultant-1200.webp",
  "how-to-optimise-your-google-business-profile":
    "/images/brand/how-to-optimise-your-google-business-profile-1200.webp",
  indexation: "/images/brand/indexation-1200.webp",
  "indexnow-and-instant-indexing": "/images/brand/indexnow-and-instant-indexing-1200.webp",
  "introduction-of-mum-and-passage-ranking":
    "/images/brand/introduction-of-mum-and-passage-ranking-1200.webp",
  "january-2025-quiet-month-big-insights":
    "/images/brand/january-2025-quiet-month-big-insights-1200.webp",
  "july-2026-ai-search-what-small-businesses-should-do-now":
    "/images/brand/july-2026-ai-search-what-small-businesses-should-do-now-1200.webp",
  "july-2026-google-core-update-recovery-playbook":
    "/images/brand/july-2026-google-core-update-recovery-playbook-1200.webp",
  "keyword-research": "/images/brand/keyword-research-1200.webp",
  legal: "/images/brand/legal-1200.webp",
  "lessons-and-predictions-for-2022": "/images/brand/lessons-and-predictions-for-2022-1200.webp",
  "lessons-from-google-s-2025-algorithm-updates":
    "/images/brand/lessons-from-google-s-2025-algorithm-updates-1200.webp",
  "local-areas": "/images/brand/local-areas-1200.webp",
  "local-search-in-2025-personalisation-and-contextual-relevance":
    "/images/brand/local-search-in-2025-personalisation-and-contextual-relevance-1200.webp",
  "local-seo-and-ai-optimising-for-voice-and-community":
    "/images/brand/local-seo-and-ai-optimising-for-voice-and-community-1200.webp",
  "local-seo-and-the-consumer-journey":
    "/images/brand/local-seo-and-the-consumer-journey-1200.webp",
  "local-seo-enhancements-in-2023": "/images/brand/local-seo-enhancements-in-2023-1200.webp",
  "local-seo-for-accountancy-firms-what-matters-most":
    "/images/brand/local-seo-for-accountancy-firms-what-matters-most-1200.webp",
  "local-seo-in-2022": "/images/brand/local-seo-in-2022-1200.webp",
  "looking-ahead-lessons-from-2024-for-the-future":
    "/images/brand/looking-ahead-lessons-from-2024-for-the-future-1200.webp",
  maintenance: "/images/brand/maintenance-1200.webp",
  "mobile-and-core-web-vitals-in-2023":
    "/images/brand/mobile-and-core-web-vitals-in-2023-1200.webp",
  "mobilefirst-indexing-gains-pace": "/images/brand/mobilefirst-indexing-gains-pace-1200.webp",
  "multi-format-content-and-diversified-channels":
    "/images/brand/multi-format-content-and-diversified-channels-1200.webp",
  "navigating-googles-2023-core-and-spam-updates":
    "/images/brand/navigating-googles-2023-core-and-spam-updates-1200.webp",
  "news-index": "/images/brand/news-index-1200.webp",
  "november-2025-digital-marketing-trends-to-watch":
    "/images/brand/november-2025-digital-marketing-trends-to-watch-1200.webp",
  "omnichannel-and-social-search": "/images/brand/omnichannel-and-social-search-1200.webp",
  "oracle-training-consultants-new-website":
    "/images/brand/oracle-training-consultants-new-website-1200.webp",
  outreach: "/images/brand/outreach-1200.webp",
  "peoplefirst-content-vs-search-enginefirst":
    "/images/brand/peoplefirst-content-vs-search-enginefirst-1200.webp",
  performance: "/images/brand/performance-1200.webp",
  "preparing-for-2021-lessons-from-2020":
    "/images/brand/preparing-for-2021-lessons-from-2020-1200.webp",
  "private-dental-seo-treatment-pages-that-convert-patients":
    "/images/brand/private-dental-seo-treatment-pages-that-convert-patients-1200.webp",
  "product-reviews-and-algorithm-updates":
    "/images/brand/product-reviews-and-algorithm-updates-1200.webp",
  "protecting-against-spam-and-algorithmic-penalties":
    "/images/brand/protecting-against-spam-and-algorithmic-penalties-1200.webp",
  "quality-content-and-e-e-a-t-raising-the-bar-for-trust":
    "/images/brand/quality-content-and-e-e-a-t-raising-the-bar-for-trust-1200.webp",
  reporting: "/images/brand/reporting-1200.webp",
  "rethinking-seo-for-2025-putting-people-before-keywords":
    "/images/brand/rethinking-seo-for-2025-putting-people-before-keywords-1200.webp",
  "salon-treatment-pages-that-improve-seo-performance":
    "/images/brand/salon-treatment-pages-that-improve-seo-performance-1200.webp",
  "search-in-a-pandemic-changing-user-behaviour":
    "/images/brand/search-in-a-pandemic-changing-user-behaviour-1200.webp",
  "sentinel-door-systems-new-website": "/images/brand/sentinel-door-systems-new-website-1200.webp",
  "seo-for-contractors-winning-higher-value-project-enquiries":
    "/images/brand/seo-for-contractors-winning-higher-value-project-enquiries-1200.webp",
  "seo-for-electricians-emergency-versus-planned-search-intent":
    "/images/brand/seo-for-electricians-emergency-versus-planned-search-intent-1200.webp",
  "seo-for-plumbers-emergency-boiler-and-bathroom-search-intent":
    "/images/brand/seo-for-plumbers-emergency-boiler-and-bathroom-search-intent-1200.webp",
  "seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google":
    "/images/brand/seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google-1200.webp",
  "seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on":
    "/images/brand/seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on-1200.webp",
  "seo-mistakes-that-cost-builders-local-leads":
    "/images/brand/seo-mistakes-that-cost-builders-local-leads-1200.webp",
  "seo-strategy": "/images/brand/seo-strategy-1200.webp",
  "seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026":
    "/images/brand/seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026-1200.webp",
  "structured-data": "/images/brand/structured-data-1200.webp",
  "structured-data-and-rich-results": "/images/brand/structured-data-and-rich-results-1200.webp",
  "tackling-zero-click-searches-turning-visibility-into-value":
    "/images/brand/tackling-zero-click-searches-turning-visibility-into-value-1200.webp",
  "the-advent-of-zeroclick-results": "/images/brand/the-advent-of-zeroclick-results-1200.webp",
  "the-rise-of-brand-seo-building-authority-for-2025":
    "/images/brand/the-rise-of-brand-seo-building-authority-for-2025-1200.webp",
  "the-rise-of-the-helpful-content-update":
    "/images/brand/the-rise-of-the-helpful-content-update-1200.webp",
  "turning-website-visitors-into-customers-with-seo":
    "/images/brand/turning-website-visitors-into-customers-with-seo-1200.webp",
  "understanding-googles-latest-algorithm-update":
    "/images/brand/understanding-googles-latest-algorithm-update-1200.webp",
  "user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond":
    "/images/brand/user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond-1200.webp",
  "video-and-visual-search": "/images/brand/video-and-visual-search-1200.webp",
  "voice-and-conversational-search": "/images/brand/voice-and-conversational-search-1200.webp",
  "voice-search-and-conversational-content":
    "/images/brand/voice-search-and-conversational-content-1200.webp",
  "voice-search-and-conversational-queries-in-2023":
    "/images/brand/voice-search-and-conversational-queries-in-2023-1200.webp",
  "volatility-and-algorithm-resilience":
    "/images/brand/volatility-and-algorithm-resilience-1200.webp",
  "web-design": "/images/brand/web-design-1200.webp",
  "website-redesign-seo-migration-checklist":
    "/images/brand/website-redesign-seo-migration-checklist-1200.webp",
  "why-consistency-matters-more-than-quick-wins-in-seo":
    "/images/brand/why-consistency-matters-more-than-quick-wins-in-seo-1200.webp",
  "why-seo-is-still-one-of-the-best-investments-for-growing-businesses":
    "/images/brand/why-seo-is-still-one-of-the-best-investments-for-growing-businesses-1200.webp",
  "why-seo-should-be-driving-your-business-growth-not-just-rankings":
    "/images/brand/why-seo-should-be-driving-your-business-growth-not-just-rankings-1200.webp",
  "why-seo-starts-with-your-website-and-always-will":
    "/images/brand/why-seo-starts-with-your-website-and-always-will-1200.webp",
  wordpress: "/images/brand/wordpress-1200.webp",
};

function resolveTopic(e: string): string | undefined {
  if (!(!e.includes("/images/generated/") && !/\/service-[^/]+\.jpg/.test(e)))
    return /about-strategy/.test(e)
      ? "keyword-research"
      : /sector-law-firms-faqs/.test(e)
        ? "contact"
        : /structured-data|schema|sector-law-firms-technical|trades-electricians-technical|trades-plumbers-technical/.test(
              e,
            )
          ? "structured-data"
          : /indexation/.test(e)
            ? "indexation"
            : /crawl|seo-audit|sector-dental-technical|trades-builders-technical|trades-contractors-technical/.test(
                  e,
                )
              ? "crawl-audit"
              : /keyword|competitor-gap|prospect-research/.test(e)
                ? "keyword-research"
                : /reporting|analytics/.test(e)
                  ? "reporting"
                  : /trust|compliance|profiles/.test(e)
                    ? "credentials"
                    : /conversion|booking|enquiry-details/.test(e)
                      ? "contact"
                      : /contact-data-access/.test(e)
                        ? "maintenance"
                        : /contact-who-i-help/.test(e)
                          ? "web-design"
                          : /local-areas?|sector-[^-]+-local/.test(e)
                            ? "local-areas"
                            : /outreach-copywriting|onpage-content|imagery|case-studies|solicitors-content/.test(
                                  e,
                                )
                              ? "wordpress"
                              : /anchor-strategy/.test(e)
                                ? "indexation"
                                : /digital-pr/.test(e)
                                  ? "outreach"
                                  : /accountant/.test(e)
                                    ? "accountants"
                                    : /solicitor|law-firm/.test(e)
                                      ? "legal"
                                      : /hairdresser/.test(e)
                                        ? "hairdressers"
                                        : /electrician/.test(e)
                                          ? "electricians"
                                          : /contact|faq/.test(e)
                                            ? "contact"
                                            : /wordpress|onpage-content|topic-content/.test(e)
                                              ? "wordpress"
                                              : /shopify|ecommerce/.test(e)
                                                ? "ecommerce"
                                                : /hosting/.test(e)
                                                  ? "hosting"
                                                  : /security|management|maintenance/.test(e)
                                                    ? "maintenance"
                                                    : /performance|web-vitals/.test(e)
                                                      ? "performance"
                                                      : /link-building|internal-linking/.test(e)
                                                        ? "outreach"
                                                        : /local-area|local-areas|about-yorkshire|service-areas/.test(
                                                              e,
                                                            )
                                                          ? "local-areas"
                                                          : /service-app|service-software/.test(e)
                                                            ? "development"
                                                            : /web-design|responsive|collaboration/.test(
                                                                  e,
                                                                )
                                                              ? "web-design"
                                                              : /technical|crawl|indexation/.test(e)
                                                                ? "performance"
                                                                : /service-pages|treatment-pages/.test(
                                                                      e,
                                                                    )
                                                                  ? "web-design"
                                                                  : /trust|compliance/.test(e)
                                                                    ? "maintenance"
                                                                    : /case-studies/.test(e)
                                                                      ? "wordpress"
                                                                      : "seo-strategy";
}

export function resolveDescribedImage(src: string): string {
  if (src.includes("/images/brand/")) return src;
  const topic = resolveTopic(src);
  if (topic && sources[topic]) return sources[topic];
  const key = src
    .split("/")
    .pop()
    ?.split("?")[0]
    .replace(/\.(jpg|png|webp|avif)$/, "");
  return key && src.includes("/images/blog/generated/") && imageDescriptions[key]
    ? sources[key] || src
    : src;
}
